/**
 * GT IO "Upload Creatives" / "Remove Creatives": which pending grid edits
 * survive a committed revision.
 *
 * The action is dispatched with the plan as it stood (pending edits included),
 * and its new revision already contains those edits. The grid stays editable
 * while it runs, so edits made in the meantime must not be lost:
 *
 *   - cell edits made after dispatch are kept — neither action adds or removes
 *     ad-group rows, so `gt-ag-<index>` keys still address the same ad groups,
 *     and being later they win over the action's values;
 *   - unless row operations rode the dispatch: row ids are positions, and the
 *     saved revision applied those operations, so a later edit's key may now
 *     name a different ad group (or none). Those edits are counted, not
 *     replayed onto the wrong row;
 *   - row / list operations made after dispatch cannot be replayed safely onto
 *     the new revision (they were built against the old one), so they are
 *     reported, not replayed.
 */
export function editsSurvivingUpload(sent, live) {
  const renumbered = (sent?.pendingRowOps?.length || 0) > 0;
  const laterCells = {};
  let droppedCells = 0;
  for (const [rowId, fields] of Object.entries(live?.editedRows || {})) {
    for (const [field, value] of Object.entries(fields || {})) {
      if (sent?.editedRows?.[rowId]?.[field] !== value) {
        if (renumbered) droppedCells += 1;
        else laterCells[rowId] = { ...(laterCells[rowId] || {}), [field]: value };
      }
    }
  }
  const structuralChanged = live?.pendingRowOps !== sent?.pendingRowOps
    || live?.pendingListOps !== sent?.pendingListOps;
  return { laterCells, structuralChanged, droppedCells };
}
